<div class="flex justify-between items-center w-full mb-4 max-h-14 h-full bg-transparent gap-2">
    <!-- <div class="flex justify-start items-center gap-2 text-xl font-normal h-full">
        <div class="cursor-pointer" *ngIf="label!=''">
            <span [ngClass]="{'text-[#000000] text-opacity-[37%]': sub_label=='text-[#212121]', '' : sub_label!='' }" class="cursor-pointer text-xl hover:text-indigo-600">{{label}} </span><span *ngIf="sub_label != ''" class="cursor-pointer"> / {{sub_label}}</span>
        </div>
    </div> -->
    <div class="cursor-pointer flex items-center text-nowrap gap-1 truncate w-auto" *ngIf="label != ''">
        <i (click)="gs.sidebar = !gs.sidebar" class='bx bx-menu text-xl sm:w-0 sm:text-transparent'></i>
        <!-- Label -->
        <span [ngClass]="{'text-opacity-[37%]': sub_label != ''}" class="text-[#000000] capitalize transition-all duration-300 cursor-pointer text-xl font-normal leading-[100%] tracking-2p hover:text-indigo-600">
            <span (click)="sub_label != '' ? gs.go_back() : ''" [ngClass]="{'select-none user': sub_label== ''}" class="flex items-center justify-between gap-2">
                <!-- <i *ngIf="show_back" class="bx bx-chevron-left"></i> -->
                {{label}}
            </span>
        </span>
        <!-- Sub Label -->
        <span *ngIf="sub_label != ''" class="text-[#212121] cursor-pointer text-xl font-medium leading-[100%] transition-all duration-300 tracking-2p">/ {{sub_label}}</span>
    </div>
    <div class="flex justify-end items-center gap-2 pr-4">

        <!-- <div class="w-10 h-10 flex justify-center items-center bg-white border border-[#3F41D1] rounded-lg cursor-pointer hover:shadow-md">
            <img src="../../../assets/CalendarDotsBlue.svg" class="w-6 h-6">
        </div> -->
        <div *ngIf="gs.user_role_data.notifications_permission" class="relative">
            <!-- Bell Button -->
            <div (click)="toggle_notifications()" class="w-10 h-10 flex justify-center items-center rounded-lg cursor-pointer hover:shadow-md relative transition-all duration-200"
                [ngClass]="is_notification_visible ? 'bg-[#3F41D1] shadow-md' : 'bg-white border border-[#3F41D1]'">
                <img src="../../../assets/bell 1.svg" class="w-6 h-6 transition-all duration-200"
                    [ngClass]="is_notification_visible ? 'brightness-0 invert' : ''">
                <span *ngIf="unread_count > 0 && !is_notification_visible" class="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 bg-red-500 rounded-full text-white text-[10px] font-bold flex items-center justify-center leading-none">
                    {{unread_count > 99 ? '99+' : unread_count}}
                </span>
            </div>

            <!-- Notification Panel -->
            <div *ngIf="is_notification_visible" class="fixed top-20 right-4 w-[400px] bg-white rounded-2xl shadow-2xl border border-gray-100 z-50 overflow-hidden">

                <!-- Header -->
                <div class="px-5 py-4 flex items-center justify-between">
                    <span class="text-lg font-bold text-gray-900">Notification</span>
                    <span *ngIf="unread_count > 0" class="px-4 py-2 bg-indigo-100 text-[#3F41D1] text-sm font-bold rounded-xl">
                        {{unread_count}} New
                    </span>
                </div>

                <!-- List -->
                <div class="max-h-[420px] overflow-y-auto px-3 pb-3 flex flex-col gap-2">
                    <ng-container *ngIf="notifications.length > 0; else no_notifications">
                        <div *ngFor="let item of notifications"
                            class="flex items-center gap-3 px-4 py-4 rounded-xl transition-colors cursor-default"
                            [ngClass]="!item.is_read ? 'bg-indigo-50' : 'bg-white border border-gray-100'">

                            <!-- Warning Icon -->
                            <div class="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                                <img src="../../../assets/warning-2.png" class="w-8 h-8" [style.opacity]="item.is_read ? '0.4' : '1'">
                            </div>

                            <!-- Content -->
                            <div class="flex-1 min-w-0">
                                <p class="text-sm font-bold" [ngClass]="item.is_read ? 'text-gray-500' : 'text-gray-900'">Exception Raised</p>
                                <p class="text-sm mt-0.5" [ngClass]="item.is_read ? 'text-gray-400' : 'text-gray-500'">Exception raised for {{item?.Script?.barcode || item?.Script?.script_id || item?.meta_data?.barcode || '-'}}.</p>
                            </div>

                        </div>
                    </ng-container>
                    <ng-template #no_notifications>
                        <div class="flex flex-col items-center justify-center py-10 gap-2 text-gray-400">
                            <i class="bx bx-bell-off text-3xl"></i>
                            <span class="text-sm">No notifications</span>
                        </div>
                    </ng-template>
                </div>

            </div>
        </div>
        <div *ngIf="gs.user_role_data.notifications_permission" class="h-7 w-[2px] bg-[#D9D9D9] ml-3 rounded-full"></div>
        <!-- <app-select-input label="Roles" class="w-[200px]" [(ngModel)]="selectedRoleId" (valueChange)="send_role_in_user_list($event)" [options]="ds.dropdown_list?.role_list"></app-select-input> -->
        <div class="relative inline-block text-left font-sans">
            <button (click)="toggle_menu_state()" class="flex items-center gap-2 p-2 hover:bg-gray-50 rounded-lg transition-all">
                <img src="../../../assets/Profile.svg" class="w-10 h-10 rounded-full object-cover" alt="Profile">
                <div class="text-left">
                    <span class="text-sm font-bold text-gray-900 leading-tight">{{ gs.user_data.name || '-' }}</span>
                    <!-- <p class="text-xs text-gray-500">{{ gs.user_data.role || 'admin@gmail.com' }}</p> -->
                </div>
                <span class="material-icons text-gray-400 text-xl">expand_more</span>
            </button>

            <div *ngIf="is_dropdown_visible" class="absolute -right-3 mt-2 w-[298px] p-4 bg-white rounded-lg shadow-2xl border border-gray-100 overflow-hidden z-50">
                <div class="flex justify-between  ">
                    <img src="../../../assets/setting.png" class="w-auto h-6  cursor-pointer" alt="Settings">
                    <div class="flex flex-col items-center gap-2 ">
                        <img src="../../../assets/Profile.svg" class="w-20 h-20 rounded-full object-cover shadow-md" alt="Profile">
                        <div class="flex flex-col items-center text-center">
                            <span class="text-lg font-semibold text-gray-800"> {{ gs.user_data.name || '-' }}</span>
                            <span class="text-sm text-gray-400"> {{ gs.user_data.Role?.name || '-' }} </span>
                        </div>
                    </div>
                    <img (click)="logout()" src="../../../assets/logout.png" class="w-auto h-6  cursor-pointer" alt="Logout">
                </div>
                <div class="border-t my-4"></div>
                <div class="felx flex-col gap-2">
                    <div class="flex items-center gap-4 ">
                        <img src="../../../assets/EnvelopeSimple.png" class="w-auto h-6  cursor-pointer" alt="Email">
                        <span class="text-sm font-normal text-gray-600 truncate w-full"> {{ gs.user_data.email || '-' }}</span>
                    </div>
                    <div class="flex items-center gap-4 ">
                        <img src="../../../assets/Phone.png" class="w-auto h-6  cursor-pointer" alt="Phone">
                        <span class="text-sm font-normal text-gray-600  w-full"> {{ gs.user_data.contact || '-' }} </span>
                    </div>
                </div>
                @if(gs.user_data.Role?.name == 'Student'){
                <div class="space-y-3 text-sm">
                    <div *ngIf="gs.user_data?.university " class="grid grid-cols-[140px_10px_1fr] items-center">
                        <span class="text-[#666666] font-medium">School</span>
                        <span class="text-[#666666] font-medium">:</span>
                        <span class="text-[#666666]"> {{ gs.user_data?.university || '-' }} </span>
                    </div>
                    <div *ngIf="gs.user_data?.stream " class="grid grid-cols-[140px_10px_1fr] items-center">
                        <span class="text-[#666666] font-medium">Stream</span>
                        <span class="text-[#666666] font-medium">:</span>
                        <span class="text-[#666666]"> {{ gs.user_data?.stream || '-' }}</span>
                    </div>
                    <div *ngIf="gs.user_data?.programme " class="grid grid-cols-[140px_10px_1fr] items-center">
                        <span class="text-[#666666] font-medium">Programme</span>
                        <span class="text-[#666666] font-medium">:</span>
                        <span class="text-[#666666]"> {{ gs.user_data?.programme || '-' }}</span>
                    </div>
                    <div *ngIf="gs.user_data?.roll " class="grid grid-cols-[140px_10px_1fr] items-center">
                        <span class="text-[#666666] font-medium">Roll Number</span>
                        <span class="text-[#666666] font-medium">:</span>
                        <span class="text-[#666666]"> {{ gs.user_data?.roll || '-' }} </span>
                    </div>
                    <div *ngIf="gs.user_data?.registration " class="grid grid-cols-[140px_10px_1fr] items-center">
                        <span class="text-[#666666] font-medium">Registration No.</span>
                        <span class="text-[#666666] font-medium">:</span>
                        <span class="text-[#666666]"> {{ gs.user_data?.registration || '-' }}</span>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>